// OutsourceActionButton.jsx - Updated with Cancel + Uncancel Outsource feature
import "bootstrap/dist/css/bootstrap.min.css";
import "./outsourceActionButton.css";
import { FaPencilAlt, FaPrint, FaTruck, FaCheckCircle, FaBan, FaUndo } from "react-icons/fa";
import React, { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { Link } from "react-router-dom";
import Outsource from "../OutSource";
import { Modal, Button, Spinner, Alert, Form } from "react-bootstrap";

function OutsourceActionButton({
  caseId,
  caseNumber,
  onStatusUpdate,
  currentCase
}) {
  const [showOutsourceModal, setShowOutsourceModal] = useState(false);
  const [showCompleteOutsourceModal, setShowCompleteOutsourceModal] = useState(false);
  const [completingOutsource, setCompletingOutsource] = useState(false);
  const [completeOutsourceError, setCompleteOutsourceError] = useState("");
  const [completeOutsourceSuccess, setCompleteOutsourceSuccess] = useState("");
  const [isLoading] = useState(false);

  const [showCancelOutsourceModal, setShowCancelOutsourceModal] = useState(false);
  const [cancellingOutsource, setCancellingOutsource] = useState(false);
  const [cancelOutsourceError, setCancelOutsourceError] = useState("");
  const [cancelOutsourceSuccess, setCancelOutsourceSuccess] = useState("");
  const [cancelReason, setCancelReason] = useState("");

  const [showUncancelOutsourceModal, setShowUncancelOutsourceModal] = useState(false);
  const [uncancellingOutsource, setUncancellingOutsource] = useState(false);
  const [uncancelOutsourceError, setUncancelOutsourceError] = useState("");
  const [uncancelOutsourceSuccess, setUncancelOutsourceSuccess] = useState("");

  const currentStatus = currentCase?.status;
  const isAlreadyCompleted = currentStatus === 'completed';
  const isAlreadyCancelled = currentStatus === 'cancelled';

  const handleCompleteOutsource = async () => {
    const outsourceCaseNumber = caseNumber;
    if (!outsourceCaseNumber) {
      setCompleteOutsourceError("Case number is missing. Cannot complete outsource.");
      return;
    }
    setCompletingOutsource(true);
    setCompleteOutsourceError("");
    setCompleteOutsourceSuccess("");
    try {
      const userLabId = localStorage.getItem('userLabId');
      const token = localStorage.getItem('token') || localStorage.getItem('accessToken');
      const cleanCaseNumber = String(outsourceCaseNumber).trim();
      const API_BASE_URL = 'https://hms.backend.hiragroupcloud.com';
      const url = `${API_BASE_URL}/api/outsource-case/complete/${cleanCaseNumber}`;
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
          "userLabId": userLabId || ''
        }
      });
      const result = await response.json();
      if (response.ok && result.success) {
        setCompleteOutsourceSuccess(`Outsource case #${cleanCaseNumber} completed successfully!`);
        if (onStatusUpdate) onStatusUpdate(result.data);
        setTimeout(() => {
          setShowCompleteOutsourceModal(false);
          setCompleteOutsourceSuccess("");
          window.location.reload();
        }, 2000);
      } else {
        setCompleteOutsourceError(result.message || "Failed to complete outsource case");
      }
    } catch (error) {
      console.error("Error completing outsource:", error);
      setCompleteOutsourceError("Network error: " + error.message);
    } finally {
      setCompletingOutsource(false);
    }
  };

  const handleCancelOutsource = async () => {
    const outsourceCaseNumber = caseNumber;
    if (!outsourceCaseNumber) {
      setCancelOutsourceError("Case number is missing. Cannot cancel outsource.");
      return;
    }
    setCancellingOutsource(true);
    setCancelOutsourceError("");
    setCancelOutsourceSuccess("");
    try {
      const userLabId = localStorage.getItem('userLabId');
      const userName = localStorage.getItem('userName') || localStorage.getItem('username') || '';
      const labName = localStorage.getItem('labName') || localStorage.getItem('currentLabName') || '';
      const token = localStorage.getItem('token') || localStorage.getItem('accessToken');
      const cleanCaseNumber = String(outsourceCaseNumber).trim();
      const API_BASE_URL = 'https://hms.backend.hiragroupcloud.com';
      const url = `${API_BASE_URL}/api/outsource-case/cancel/${cleanCaseNumber}`;
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
          "userLabId": userLabId || '',
          "x-user-lab-id": userLabId || '',
          "x-user-data": JSON.stringify({ userLabId, userName, labName })
        },
        body: JSON.stringify({ reason: cancelReason.trim() })
      });
      const result = await response.json();
      if (response.ok && result.success) {
        setCancelOutsourceSuccess(`Outsource case #${cleanCaseNumber} has been cancelled.`);
        if (onStatusUpdate) onStatusUpdate(result.data);
        setTimeout(() => {
          setShowCancelOutsourceModal(false);
          setCancelOutsourceSuccess("");
          setCancelReason("");
          window.location.reload();
        }, 2000);
      } else {
        setCancelOutsourceError(result.message || "Failed to cancel outsource case");
      }
    } catch (error) {
      console.error("Error cancelling outsource:", error);
      setCancelOutsourceError("Network error: " + error.message);
    } finally {
      setCancellingOutsource(false);
    }
  };

  const handleUncancelOutsource = async () => {
    const outsourceCaseNumber = caseNumber;
    if (!outsourceCaseNumber) {
      setUncancelOutsourceError("Case number is missing. Cannot reactivate outsource.");
      return;
    }
    setUncancellingOutsource(true);
    setUncancelOutsourceError("");
    setUncancelOutsourceSuccess("");
    try {
      const userLabId = localStorage.getItem('userLabId');
      const userName = localStorage.getItem('userName') || localStorage.getItem('username') || '';
      const labName = localStorage.getItem('labName') || localStorage.getItem('currentLabName') || '';
      const token = localStorage.getItem('token') || localStorage.getItem('accessToken');
      const cleanCaseNumber = String(outsourceCaseNumber).trim();
      const API_BASE_URL = 'https://hms.backend.hiragroupcloud.com';
      const url = `${API_BASE_URL}/api/outsource-case/uncancel/${cleanCaseNumber}`;
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
          "userLabId": userLabId || '',
          "x-user-lab-id": userLabId || '',
          "x-user-data": JSON.stringify({ userLabId, userName, labName })
        }
      });
      const result = await response.json();
      if (response.ok && result.success) {
        setUncancelOutsourceSuccess(`Outsource case #${cleanCaseNumber} has been reactivated.`);
        if (onStatusUpdate) onStatusUpdate(result.data);
        setTimeout(() => {
          setShowUncancelOutsourceModal(false);
          setUncancelOutsourceSuccess("");
          window.location.reload();
        }, 2000);
      } else {
        setUncancelOutsourceError(result.message || "Failed to reactivate outsource case");
      }
    } catch (error) {
      console.error("Error uncancelling outsource:", error);
      setUncancelOutsourceError("Network error: " + error.message);
    } finally {
      setUncancellingOutsource(false);
    }
  };

  return (
    <>
      <Dropdown>
        <Dropdown.Toggle
          variant="primary"
          className="outsource-actions-toggle"
          id="dropdown-outsource-actions"
          disabled={isLoading}
        >
          <FaPencilAlt className="me-2" /> {isLoading ? "Loading..." : "Outsource Actions"}
        </Dropdown.Toggle>
        <Dropdown.Menu className="outsource-actions-menu">
          <Dropdown.Item
            as={Link}
            to={`/outsource-print-work-ticket/${caseNumber}`}
            className="outsource-action-item"
          >
            <FaPrint className="me-2" /> Print Work Ticket
          </Dropdown.Item>

          <Dropdown.Item
            as={Link}
            to={`/outsource-sticker/${caseNumber}`}
            className="outsource-action-item"
          >
            <FaPrint className="me-2" /> Print Work Ticket Sticker
          </Dropdown.Item>

          <hr className="dropdown-divider outsource-divider" />

          <Dropdown.Item
            onClick={() => setShowOutsourceModal(true)}
            className="outsource-action-item"
          >
            <FaTruck className="me-2" /> Add Outsource
          </Dropdown.Item>

          <hr className="dropdown-divider outsource-divider" />

          {!isAlreadyCancelled && (
            <Dropdown.Item
              onClick={() => setShowCompleteOutsourceModal(true)}
              disabled={isAlreadyCompleted}
              className={`outsource-action-item complete-item ${isAlreadyCompleted ? 'disabled-item' : ''}`}
            >
              <FaCheckCircle className="me-2" /> Complete Outsource
            </Dropdown.Item>
          )}

          {!isAlreadyCompleted && !isAlreadyCancelled && (
            <Dropdown.Item
              onClick={() => setShowCancelOutsourceModal(true)}
              className="outsource-action-item cancel-item"
            >
              <FaBan className="me-2" /> Cancel Outsource
            </Dropdown.Item>
          )}

          {isAlreadyCancelled && (
            <Dropdown.Item
              onClick={() => setShowUncancelOutsourceModal(true)}
              className="outsource-action-item uncancel-item"
            >
              <FaUndo className="me-2" /> Uncancel Outsource
            </Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Dropdown>

      <Outsource
        showModal={showOutsourceModal}
        handleClose={() => setShowOutsourceModal(false)}
        caseId={caseId}
        caseNumber={caseNumber}
      />

      {/* ===== Complete Outsource Modal ===== */}
      <Modal
        show={showCompleteOutsourceModal}
        onHide={() => {
          setShowCompleteOutsourceModal(false);
          setCompleteOutsourceError("");
          setCompleteOutsourceSuccess("");
        }}
        centered
        size="md"
      >
        <Modal.Header closeButton className="outsource-modal-header-success">
          <Modal.Title className="outsource-modal-title">
            <FaCheckCircle className="me-2" /> Complete Outsource Case
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="outsource-modal-body">
          {completeOutsourceError && (
            <Alert variant="danger" onClose={() => setCompleteOutsourceError("")} dismissible>
              {completeOutsourceError}
            </Alert>
          )}
          {completeOutsourceSuccess && (
            <Alert variant="success" onClose={() => setCompleteOutsourceSuccess("")} dismissible>
              {completeOutsourceSuccess}
            </Alert>
          )}
          {!completeOutsourceSuccess && (
            <>
              <div className="outsource-alert-warning">
                <p>
                  <strong>⚠️ Important:</strong> You are about to mark this outsource case as completed.
                </p>
              </div>
              <div className="outsource-info-box">
                <p className="case-number">
                  <strong>Case Number:</strong> {caseNumber || 'N/A'}
                </p>
                <p className="info-text">
                  This action will mark the outsource case as completed and notify the other party.
                  This cannot be undone.
                </p>
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowCompleteOutsourceModal(false);
              setCompleteOutsourceError("");
              setCompleteOutsourceSuccess("");
            }}
            disabled={completingOutsource}
          >
            Cancel
          </Button>
          {!completeOutsourceSuccess && (
            <Button
              variant="success"
              onClick={handleCompleteOutsource}
              disabled={completingOutsource || !caseNumber}
              className="outsource-modal-btn"
            >
              {completingOutsource ? (
                <>
                  <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="outsource-spinner" />
                  Completing...
                </>
              ) : (
                "Complete Outsource ✅"
              )}
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      {/* ===== Cancel Outsource Modal ===== */}
      <Modal
        show={showCancelOutsourceModal}
        onHide={() => {
          setShowCancelOutsourceModal(false);
          setCancelOutsourceError("");
          setCancelOutsourceSuccess("");
          setCancelReason("");
        }}
        centered
        size="md"
      >
        <Modal.Header closeButton className="outsource-modal-header-danger">
          <Modal.Title className="outsource-modal-title">
            <FaBan className="me-2" /> Cancel Outsource Case
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="outsource-modal-body">
          {cancelOutsourceError && (
            <Alert variant="danger" onClose={() => setCancelOutsourceError("")} dismissible>
              {cancelOutsourceError}
            </Alert>
          )}
          {cancelOutsourceSuccess && (
            <Alert variant="success" onClose={() => setCancelOutsourceSuccess("")} dismissible>
              {cancelOutsourceSuccess}
            </Alert>
          )}
          {!cancelOutsourceSuccess && (
            <>
              <div className="outsource-alert-danger">
                <p>
                  <strong>⚠️ Warning:</strong> You are about to cancel this outsource case. You can reactivate it later using "Uncancel Outsource".
                </p>
              </div>
              <div className="outsource-info-box with-margin">
                <p className="case-number no-margin">
                  <strong>Case Number:</strong> {caseNumber || 'N/A'}
                </p>
              </div>
              <Form.Group>
                <Form.Label className="outsource-form-label">Reason (Optional)</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={cancelReason}
                  onChange={(e) => setCancelReason(e.target.value)}
                  placeholder="Why is this outsource case being cancelled?"
                />
                <Form.Text className="text-muted outsource-form-text">
                  This reason will be visible to the other lab.
                </Form.Text>
              </Form.Group>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowCancelOutsourceModal(false);
              setCancelOutsourceError("");
              setCancelOutsourceSuccess("");
              setCancelReason("");
            }}
            disabled={cancellingOutsource}
          >
            Close
          </Button>
          {!cancelOutsourceSuccess && (
            <Button
              variant="danger"
              onClick={handleCancelOutsource}
              disabled={cancellingOutsource || !caseNumber}
              className="outsource-modal-btn"
            >
              {cancellingOutsource ? (
                <>
                  <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="outsource-spinner" />
                  Cancelling...
                </>
              ) : (
                "Cancel Outsource 🚫"
              )}
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      {/* ===== Uncancel Outsource Modal ===== */}
      <Modal
        show={showUncancelOutsourceModal}
        onHide={() => {
          setShowUncancelOutsourceModal(false);
          setUncancelOutsourceError("");
          setUncancelOutsourceSuccess("");
        }}
        centered
        size="md"
      >
        <Modal.Header closeButton className="outsource-modal-header-success">
          <Modal.Title className="outsource-modal-title">
            <FaUndo className="me-2" /> Uncancel Outsource Case
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="outsource-modal-body">
          {uncancelOutsourceError && (
            <Alert variant="danger" onClose={() => setUncancelOutsourceError("")} dismissible>
              {uncancelOutsourceError}
            </Alert>
          )}
          {uncancelOutsourceSuccess && (
            <Alert variant="success" onClose={() => setUncancelOutsourceSuccess("")} dismissible>
              {uncancelOutsourceSuccess}
            </Alert>
          )}
          {!uncancelOutsourceSuccess && (
            <>
              <div className="outsource-alert-success">
                <p>
                  <strong>Reactivate this case:</strong> The case will be restored to its status right before it was cancelled, and the other lab will be notified.
                </p>
              </div>
              <div className="outsource-info-box">
                <p className="case-number no-margin">
                  <strong>Case Number:</strong> {caseNumber || 'N/A'}
                </p>
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowUncancelOutsourceModal(false);
              setUncancelOutsourceError("");
              setUncancelOutsourceSuccess("");
            }}
            disabled={uncancellingOutsource}
          >
            Close
          </Button>
          {!uncancelOutsourceSuccess && (
            <Button
              variant="success"
              onClick={handleUncancelOutsource}
              disabled={uncancellingOutsource || !caseNumber}
              className="outsource-modal-btn"
            >
              {uncancellingOutsource ? (
                <>
                  <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="outsource-spinner" />
                  Reactivating...
                </>
              ) : (
                "Uncancel Outsource ✅"
              )}
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default OutsourceActionButton;